import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '../App';

import '../stylesheets/login.css';

const rootElement = document.getElementById('root');

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

  const login = document.getElementById('loginContainer');

  if (login) login.style.visibility = '';